module.exports = __webpack_public_path__ + "img/p4-c2-p4.ecfa4e2f.jpg";